/*
 * @Copyright: @ Silk Software Corp. All Rights Reserved Based on SILK-LICENSE
 */
import { Component as AppComponent } from 'react'
import { initApollo } from './initApollo'

/**
 * Creates and provides the apolloContext
 * to a create-react-app PageTree. Use it by wrapping
 * your App via HOC pattern.
 * @param {Function|Class} App
 */
const withApollo = (App) => {
  return class AppWithApollo extends AppComponent {
    constructor(props) {
      super(props)
      this.apolloClient = initApollo({
        apolloState: {}
      })
    }

    render() {
      return <App apolloClient={this.apolloClient} {...this.props} />
    }
  }
}

export default withApollo
